export const API_URL = process.env.REACT_APP_API_URL;
export const API_PROXY_URL = process.env.REACT_APP_PROXY_SERVER_URL;
export const BASE_PATH = "/app";
export const DRAWER_WIDTH = 256;
export const DRAWER_MINI_WIDTH = 72;

// If you are changing APP_VER please make sure to change X-APP-VERSION in
// app/views/partials/shared/api/headers.liquid
export const APP_VER = "1.0.5";
